import { IStyle, ITheme } from '@fluentui/react/lib/Styling';

export default function surfaceFocusStyles(
    position: 'absolute' | 'relative',
    theme: ITheme,
    useBoldTheme: boolean
): IStyle {
    const borderColor = useBoldTheme ? theme.palette.white : 'transparent';
    const outlineColor = theme.palette.neutralSecondary;

    return {
        // Clear browser-specific focus styles and use 'transparent' as placeholder for focus style.
        outline: 'transparent',
        // Requirement because pseudo-element is absolutely positioned.
        position,

        selectors: {
            // Clear the focus border in Firefox.
            // Reference: http://stackoverflow.com/a/199319/1436671
            '::-moz-focus-inner': {
                border: '0',
            },

            // When the element that uses this mixin is in a :focus state, add a pseudo-element to
            // create a border.
            ['.ms-Fabric--isFocusVisible &:focus:after']: {
                content: '""',
                position: 'absolute',
                left: 1,
                top: 1,
                bottom: 1,
                right: 1,
                border: `1px solid ${borderColor}`,
                outline: `1px solid ${outlineColor} !important`, // override the global .addFocusOutline transparency
                zIndex: 1,
            },
        },
    };
}
